'use client'

import { useState } from 'react'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetClose,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { Button } from '@/components/ui/button'
import { Heart } from 'lucide-react'

import { type MenuItem } from '@/lib/api/navigation/navigation.types'
import Link from 'next/link'
import Image from 'next/image'
import { Language } from '@/localization/localization.types'
import WishlistButton from '../navigation-container/wishlist-button'
import LanguageMenu from '../navigation-container/language-menu'
import MobileMenuContent from './mobile-menu-content'

interface MobileNavigationProps {
  menuItems: MenuItem[]
  lang: Language
}

const imageAds = [
  {
    url: '/images/nav-2.jpeg',
    title: 'A new way of business',
    description: 'Create your beauty career with Déesse',
  },
  {
    url: '/images/nav-1.png',
    title: 'New in',
    description: 'Special Serums',
  },
]

const MobileNavigation = ({ menuItems, lang }: MobileNavigationProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger className="sm:hidden">
        <Image
          priority
          src={'/icons/menu.svg'}
          height={24}
          width={24}
          alt={'menu'}
          className="size-6 cursor-pointer"
        />
      </SheetTrigger>

      <SheetContent aria-describedby={undefined} className="w-full overflow-auto p-0 sm:max-w-full">
        <SheetTitle className="sr-only">Navigation menu</SheetTitle>
        <SheetHeader className="bg-grey-50 px-4.5 py-2.5">
          <div className="flex w-full items-center justify-between">
            <div className="w-[93px] sm:max-md:ml-7.5 sm:max-md:w-[124px]">
              <Link href={'/'}>
                <Image
                  width={93}
                  height={60}
                  quality={100}
                  src={'/images/logo.svg'}
                  alt={'/images/logo.png'}
                  className="h-full w-full object-cover"
                />
              </Link>
            </div>

            <div className="flex items-center gap-4">
              <SheetClose>
                <Image
                  width={24}
                  height={24}
                  src={'/icons/close.svg'}
                  alt={'/icons/close.svg'}
                  className="cursor-pointer"
                />
              </SheetClose>
            </div>
          </div>
        </SheetHeader>
        <div className="mr-1 flex items-center justify-end gap-4 bg-white px-4.5 py-2">
          <WishlistButton
            fallback={
              <Button variant={'plain'} size={'plain'}>
                <Heart strokeWidth={1} className="size-6 text-black" />
              </Button>
            }
          />
          <LanguageMenu lang={lang} />
        </div>
        <MobileMenuContent
          menuItems={menuItems}
          imageAds={imageAds}
          setIsOpen={setIsOpen}
        />
      </SheetContent>
    </Sheet>
  )
}

export default MobileNavigation
